var $e0a3af6ac1449b2f$exports = {};
$e0a3af6ac1449b2f$exports = {
  "decrease": function decrease(args) {
    return "Smanji ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Pove\u0107aj ".concat(args.fieldLabel);
  },
  "numberField": "Polje broja"
};
export { $e0a3af6ac1449b2f$exports as default };